// 會員頭像(後台用)
// 為什麼有這個元件(2026-10-06 客戶「會員照片為了好記」):客戶是靠 LINE 頭像 + 暱稱認人,
// picture_url 從加好友 / LIFF 登入就存進 members doc,但後台一直沒顯示。
// 沒有頭像(手動建的會員、對方沒設)或圖片載入失敗(LINE 的圖片網址可能過期)→ 退回姓名首字的圓形底。
import { useEffect, useState } from "react";

export default function MemberAvatar({
  src,
  name,
  size = 40,
}: {
  /** LINE 頭像網址(members.picture_url) */
  src?: string;
  /** 取首字用的姓名(真名優先,沒有就用暱稱) */
  name?: string;
  /** 直徑 px */
  size?: number;
}) {
  const [broken, setBroken] = useState(false);
  // 換了網址(例如按「更新 LINE 資料」後)要重新嘗試載入
  useEffect(() => setBroken(false), [src]);

  const box = { width: size, height: size };
  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
        style={box}
        className="rounded-full object-cover shrink-0 bg-line"
      />
    );
  }
  // Array.from 才不會把 emoji 暱稱的首字切成半個字元
  const initial = Array.from((name || "").trim())[0] || "?";
  return (
    <span
      style={{ ...box, fontSize: Math.round(size * 0.42) }}
      className="inline-flex items-center justify-center rounded-full shrink-0 bg-cream text-primary border border-line font-medium select-none"
      aria-hidden="true"
    >
      {initial}
    </span>
  );
}
